import React, { useEffect, useState } from 'react';
import '../CSS/Loder.css';

const Loder = () => {
  const [hide, setHide] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHide(true);
    }, 2000); // loader visible for 4.5s

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`wedding-loader ${hide ? 'fade-out' : ''}`}>
      <div className="rings-container">
        <div className="ring ring1"></div>
        <div className="ring ring2"></div>
        <div className="ring ring3"></div>
        <div className="heart-pulse">&#10084;</div>
      </div>

      <div className="sparkles">
        {[...Array(25)].map((_, i) => (
          <span key={i} className="sparkle"></span>
        ))}
      </div>

      <div className="loader-text">
        <h1>Libra Events And Decoration</h1>
        <p>Best wedding halls in Vadodara</p>
      </div>
    </div>
  );
};

export default Loder;
